
import _ from "@lodash";
import { Checkbox, Collapse, FormControl, FormControlLabel, Grid, InputAdornment, MenuItem, Paper, Switch, TextField, Typography, withStyles } from "@material-ui/core";
import XAPPButton from "app/Core/Components/Button/XAPPButton";
import ImageUploader from "app/Core/Components/ImageUploader/ImageUploader";
import XAPPComponent from "app/Core/Components/XAPPComponent/XAPPComponent";
import * as Helpers from "app/Core/Helpers";
import CidadeApp from "app/ERP/Cidade/CidadeApp";
import * as AppActions from "app/store/actions";
import withReducer from "app/store/withReducer";
import clsx from "clsx";
import MobileDetect from "mobile-detect";
import React from "react";
import { FaFacebook, FaInstagram, FaVideo, FaWhatsapp } from "react-icons/fa";
import { MdMail, MdPhone, MdPhoneAndroid } from "react-icons/md";
import InputMask from "react-input-mask";
import connect from "react-redux/es/connect/connect";
import { withRouter } from "react-router-dom";
import { bindActionCreators } from "redux";
import * as Actions from "./Store/Actions/FormPessoaActions";
import reducer from "./Store/Reducers/FormPessoaReducer";
import FuncionalidadeTagApp from "app/ERP/FuncionalidadeTag/FuncionalidadeTagApp";
import SuggestionField from "app/Core/Components/SuggestionField/SuggestionField";
import EmpresaCentroCustoApp from "app/ERP/EmpresaCentroCusto/EmpresaCentroCustoApp";
import EmpresaPessoaApp from "app/ERP/EmpresaPessoa/EmpresaPessoaApp";

const md = new MobileDetect(window.navigator.userAgent);

const styles = (theme) => ({
    root: {
        color: theme.palette.text.primary,
    },
    paper: {
        padding: "5px 4px",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        border: "1px solid " + theme.palette.divider,
        borderRadius: 2,
        maxHeight: "56px",
        width: "100%"
    },
    cor: {
        color: theme.palette.text.primary,
    },
    GridItemSwitch: {
        padding: "5px 4px",
        display: "flex",
        alignItems: "center",
        color: theme.palette.text.primary,
    },
    chipSelect: {
        "& .fuse-chip-select__indicators": {
            display: "none"
        }
    },
    group: {},
    formControl: {
        margin: "0px 0",
        width: "100%",
        "&:last-child": {
            marginBottom: 0,
        },
    },
    formGroupTitle: {
        position: "absolute",
        top: -10,
        left: 8,
        fontWeight: 600,
        padding: "0 4px",
        backgroundColor: theme.palette.type === "dark" ? "#424242" : "#FFF",
        fontSize: "12px",
    },
    formGroup: {
        position: "relative",
        //maxHeight: '58px',
        border: "1px solid " + theme.palette.divider,
        borderRadius: 2,
    },
});

class FormPessoa extends XAPPComponent {

    state = {
        openCollapse: 0
    };

    componentDidUpdate() {
        if (this.props.FormPessoa.error) {
            this.props.showMessage({
                message: this.props.FormPessoa.error,
                variant: "error"
            });
            this.props.FormPessoa.error = null;
        }
        if (this.props.FormPessoa.warning) {
            this.props.showMessage({
                message: this.props.FormPessoa.warning,
                variant: "warning"
            });
            this.props.FormPessoa.warning = null;
        }
        if (this.props.FormPessoa.info) {
            this.props.showMessage({
                message: this.props.FormPessoa.info,
                variant: "success"
            });
            this.props.FormPessoa.info = null;
        }
    }

    handleImage = (_AItem, _AName) => {
        var AEvent = { target: { name: _AName, value: _AItem } };
        this.props.onChange(AEvent);
    };

    handleCheck = (ev) => {
        var AEvent = { target: { name: ev.target.name, value: ev.target.checked ? "2" : "1" } };
        this.props.onChange(AEvent);
    };

    openCollapse = (_AID) => {
        if (_.isNull(this.state.openCollapse) || !_.isEqual(this.state.openCollapse, _AID)) {
            this.setState({ openCollapse: _AID });
        }
        else {
            this.setState({ openCollapse: null });
        }
    };

    changeRemoveMask = (_AValue) => {
        this.setState(_.set({ ...this.state }, _AValue, !this.state[_AValue]));
    };

    handleLookupCidade = (_AValue, fieldId) => {
        var obj = {};
        if (_AValue !== null && _AValue.length > 0) {
            obj[fieldId] = _AValue[0].id;
            obj["uf"] = _AValue[0].uf;
            obj[fieldId + "_nome"] = _AValue[0].cidade + " - " + _AValue[0].pais;
        }
        else {
            obj[fieldId] = null;
            obj[fieldId + "_nome"] = null;
        }
        this.props.onChangeForm(obj);
    };

    handleLookupEmpresaCentroCusto = (_AValue) => {
        var obj = this.state;
        if (!_.isUndefined(_AValue) && !_.isNull(_AValue) && _AValue.length > 0) {
            let AItem = _AValue[_AValue.length - 1];
            obj.idpessoaformulariocentrocusto = AItem.idpessoaformulario;
            obj.idpessoaformulariocentrocustodescricao = AItem.nome;
        } else {
            obj.idpessoaformulariocentrocusto = undefined;
            obj.idpessoaformulariocentrocustodescricao = undefined;
        }
        this.props.onChangeForm(obj);
    };

    handleLookupPessoa = (_AValue, fieldId) => {
        var obj = this.state;
        if (!_.isUndefined(_AValue) && !_.isNull(_AValue) && _AValue.length > 0) {
            obj[fieldId] = _AValue[0].idpessoaformulario;
            obj[fieldId + "_nome"] = _AValue[0].nome;
        }
        else {
            obj[fieldId] = null;
            obj[fieldId + "_nome"] = null;
        }
        this.props.onChangeForm(obj);
    };

    changeFuncionario = () => {
        this.props.changeFuncionario(this.props.formulario, this.props.xappRouteParams);
    };

    getTipos = () => {
        const { tipos = null } = this.props.FormPessoa;
        let AResponse = [];
        if (!_.isNull(tipos)) {
            tipos.forEach(item => {
                AResponse.push({ ...item, value: item.id });
            });
        }
        return AResponse;
    };

    tiposToComponent = (_ASelected) => {
        var AResponse = [];
        if (!_.isUndefined(_ASelected) && !_.isNull(_ASelected) && _ASelected.length > 0) {
            this.getTipos().forEach(item => {
                if (_ASelected.includes(item.value)) {
                    AResponse.push(item);
                }
            });
        }
        return AResponse;
    };

    handleChangeTipos = (itens) => {
        const { onChange } = this.props;
        var ATmp = [];
        itens.forEach(item => {
            ATmp.push(item.value);
        });
        onChange({ target: { name: "tipo", value: ATmp } });
    };

    render() {
        const { xappRouteParams, classes, formulario, onChange, onChangeMask, readOnly, customProps = null } = this.props;
        const form = this.state;
        return (
            <React.Fragment>
                <div className="w-full">
                    <div className="flex sm:flex-row flex-col w-full">
                        {!readOnly && !_.isNull(customProps) && customProps["natureza"].show &&
                            <div className={"flex flex-rol mb-12 w-full sm:mr-8"}>
                                <Paper className={clsx(classes.paper, "rounded-6")} elevation={0} rounded={true}>
                                    <div className={classes.GridItemSwitch}>
                                        <Grid item>Física</Grid>
                                    </div>
                                    <Grid component="label" alignItems="center" spacing={1}>
                                        <Grid item>
                                            <Switch
                                                onChange={this.handleCheck}
                                                name={"natureza"}
                                                disabled={readOnly}
                                                value={formulario.natureza}
                                                checked={formulario.natureza === "2" ? true : false}
                                            />
                                        </Grid>
                                    </Grid>
                                    <div className={classes.GridItemSwitch}>
                                        <Grid item>Jurídica</Grid>
                                    </div>
                                </Paper>
                            </div>
                        }
                        {!readOnly && customProps["tags"].show &&
                            <div
                                className={clsx(classes.formGroup, "w-full flex flex-row rounded-6 mb-12 py-2 h-56")}                 >
                                <Typography className={classes.formGroupTitle} color="textSecondary">
                                    {"Tags"}
                                </Typography>
                                <FormControl component="span" className={classes.formControl} key={"Tags_Paper"} name={"Tags_Paper"}>
                                    {/* <TagFormulario
                                        key={"TagFormularioFormulario"}
                                        tags={customProps.tags?.data}
                                        selected={formulario.tags}
                                        target="tags"
                                        onChange={onChange}
                                        xappRouteParams={xappRouteParams}
                                        refreshTags={customProps.tags?.callback}
                                        tipo={customProps.tags?.tipo}
                                        className="text-20"
                                    /> */}
                                    <FuncionalidadeTagApp
                                        target="pessoaformulariotag"
                                        campoid="idpessoaformulario"
                                        foreingkey={customProps.tags?.foreingkey}
                                        xappRouteParams={xappRouteParams}
                                        refreshTags={customProps.tags?.callback}
                                        tags={customProps.tags?.data}
                                        tipo={customProps.tags?.tipo}
                                    />
                                </FormControl>
                            </div>
                        }
                    </div>

                    {/** DADOS PESSOAIS / EMPRESARIAS */}
                    <React.Fragment>
                        <div className="flex p-8 items-center">
                            <Typography className="inline font-medium" color="primary" paragraph={false}>
                                {"Dados gerais"}
                            </Typography>
                        </div>
                        <div className="flex sm:flex-no-wrap flex-wrap items-center justify-center">
                            <div className="mb-12 mr-8">
                                <ImageUploader
                                    onChange={this.handleImage}
                                    image={formulario.foto}
                                    name={"foto"}
                                    width={300}
                                    showtoolbar={true}
                                    height={250}
                                    border={50}
                                    scale={1}
                                    disabled={readOnly}
                                />
                            </div>
                            <div className="w-full">
                                <div className="flex sm:flex-no-wrap flex-wrap sm:w-5/8 w-full">
                                    <span className="hidden">{formulario.uid}</span>
                                    <span className="hidden">{formulario.tipo}</span>
                                    <SuggestionField
                                        className="mb-12 lg:w-2/6 sm:w-full md:mr-8"
                                        name="nome"
                                        label={formulario.natureza === "2" ? "Razão social" : "Nome"}
                                        xappRouteParams={xappRouteParams}
                                        target={customProps["nome"]?.target}
                                        campoID={"idpessoaformulario"}
                                        campoFiltro={"UPPER(pessoaformulario.formulario->>''nome'')"}
                                        required
                                        value={formulario.nome}
                                        onSelected={customProps["nome"]?.onSelected}
                                        onChange={onChange}
                                    />
                                    {!_.isNull(customProps) && customProps["nomesocial"].show &&
                                        <TextField
                                            className="mb-12 lg:w-2/6 sm:w-full"
                                            label={formulario.natureza === "2" ? "Nome fantasia" : "Nome social"}
                                            id="nomesocial"
                                            name="nomesocial"
                                            disabled={readOnly}
                                            value={formulario.nomesocial}
                                            onChange={onChange}
                                            variant="outlined"
                                            fullWidth
                                            InputLabelProps={{
                                                shrink: formulario.nomesocial !== null
                                            }}
                                        />
                                    }
                                </div>
                                <div className="flex sm:flex-no-wrap flex-wrap sm:w-5/8 w-full">
                                    {!_.isNull(customProps) && customProps["sexo"].show && formulario.natureza === "1" &&
                                        <TextField
                                            className="mb-12 lg:w-2/6 sm:w-full md:mr-8"
                                            label={"Sexo"}
                                            id="sexo"
                                            name="sexo"
                                            disabled={readOnly}
                                            value={formulario.sexo}
                                            onChange={onChange}
                                            variant="outlined"
                                            fullWidth
                                            select
                                            InputLabelProps={{
                                                shrink: formulario.sexo !== null
                                            }}
                                        >
                                            <MenuItem key={"MenuItem_" + 1} value={1}>{"Masculino"}</MenuItem>
                                            <MenuItem key={"MenuItem_" + 2} value={2}>{"Feminino"}</MenuItem>
                                        </TextField>
                                    }
                                    {!_.isNull(customProps) && customProps["nascimentoabertura"].show &&
                                        <TextField
                                            className="mb-12 lg:w-2/6 sm:w-full md:mr-8"
                                            label={formulario.natureza === "2" ? "Data de abertura" : "Data de nascimento"}
                                            id="nascimentoabertura"
                                            name="nascimentoabertura"
                                            disabled={readOnly}
                                            value={formulario.nascimentoabertura}
                                            onChange={onChange}
                                            variant="outlined"
                                            fullWidth
                                            type="date"
                                            InputLabelProps={{
                                                shrink: formulario.nascimentoabertura !== null
                                            }}
                                        />
                                    }
                                    {!_.isNull(customProps) && customProps["obito"].show && (
                                        <React.Fragment>
                                            {Helpers.isSafari() ?
                                                <InputMask
                                                    mask="99/99/9999"
                                                    maskChar={null}
                                                    value={formulario.obito?.split("-").reverse().join("/")}
                                                    onChange={(ev) => {
                                                        if (Helpers.ParseDate(ev.target.value)) {
                                                            onChange({ target: { name: "obito", type: "date", value: ev.target.value.split("/").reverse().join("-") } });
                                                        }
                                                        else {
                                                            onChange(ev);
                                                        }
                                                    }}
                                                    disabled={readOnly}
                                                >
                                                    {() => <TextField
                                                        className="mb-12 lg:w-2/6 sm:w-full"
                                                        label={"Data de óbito"}
                                                        id="obito"
                                                        name="obito"
                                                        variant="outlined"
                                                        fullWidth
                                                        disabled={readOnly}
                                                        InputLabelProps={{
                                                            shrink: formulario.obito !== null
                                                        }}
                                                    />
                                                    }
                                                </InputMask>
                                                :
                                                <TextField
                                                    className="mb-12 lg:w-2/6 sm:w-full"
                                                    label={"Data de óbito"}
                                                    id="obito"
                                                    name="obito"
                                                    disabled={readOnly}
                                                    value={formulario.obito}
                                                    onChange={onChange}
                                                    variant="outlined"
                                                    fullWidth
                                                    type="date"
                                                    InputLabelProps={{
                                                        shrink: formulario.obito !== null
                                                    }}
                                                />
                                            }
                                        </React.Fragment>
                                    )
                                    }
                                </div>
                            </div>
                        </div>
                        {!_.isNull(customProps) && customProps["origem"].show &&
                            <div className='flex flex-col w-full sm:flex-no-wrap flex-wrap'>
                                <div className="flex sm:flex-no-wrap flex-wrap w-full">
                                    <TextField
                                        className="mb-12 lg:w-1/3 xs:w-full md:mr-8"
                                        label={"Origem"}
                                        id="origem"
                                        name="origem"
                                        disabled={readOnly}
                                        value={formulario.origem}
                                        onChange={onChange}
                                        variant="outlined"
                                        fullWidth
                                        InputLabelProps={{
                                            shrink: formulario.origem !== null
                                        }}
                                        select
                                    >
                                        {Helpers.GetOrigensPessoa().map(item => (
                                            <MenuItem key={item.id} value={item.id}>{item.label}</MenuItem>
                                        ))}
                                    </TextField>
                                    {String(formulario.origem) === "6" ?
                                        <EmpresaPessoaApp
                                            className="mb-12 lg:w-2/3 xs:w-full"
                                            xappRouteParams={xappRouteParams}
                                            selected={!_.isNull(formulario?.origemdescricao) && formulario.origemdescricao !== "" ? [{ "idpessoaformulario": formulario.origemdescricao, "nome": formulario.origemdescricao_nome }] : []}
                                            label={"Indicação"}
                                            id={"LookupIndicacaoPessoa"}
                                            onChange={ev => this.handleLookupPessoa(ev, "origemdescricao")}
                                            required={false}
                                            isLookup={true}
                                            multiSelect={false}
                                            showNovo={false}
                                        />
                                        :
                                        <TextField
                                            className="mb-12 lg:w-2/3 xs:w-full"
                                            label={"Descrição origem"}
                                            id="origemdescricao"
                                            name="origemdescricao"
                                            disabled={readOnly}
                                            value={formulario.origemdescricao}
                                            onChange={onChange}
                                            variant="outlined"
                                            fullWidth
                                            InputLabelProps={{
                                                shrink: formulario.origemdescricao !== null
                                            }}
                                        />
                                    }
                                </div>
                            </div>
                        }
                    </React.Fragment>
                    {/** DADOS DE CONTATO */}
                    {!_.isNull(customProps) && customProps["contatos"].show &&
                        <React.Fragment>
                            <div className="flex px-8 items-center cursor-pointer" onClick={() => this.openCollapse(0)}>
                                <Typography className="inline font-medium" color="primary" paragraph={false}>
                                    {"Contatos"}
                                </Typography>
                                <div className="flex-1" />
                                <XAPPButton
                                    noHover={true}
                                    type="icon"
                                    icon={form.openCollapse === 0 ? "arrow_up" : "arrow_down"}
                                    onClick={() => { }}
                                />
                            </div>
                            <Collapse in={form.openCollapse === 0} timeout="auto" unmountOnExit className="">
                                <div className="flex md:flex-no-wrap flex-wrap">
                                    <div className="flex mb-12 md:w-1/3 xs:w-full md:mr-8">
                                        <TextField
                                            className="mb-12 mr-4 md:mr-8 w-96"
                                            id="foneprefix"
                                            name="foneprefix"
                                            variant="outlined"
                                            value={formulario.foneprefix}
                                            fullWidth
                                            onChange={onChange}
                                            disabled={readOnly}
                                            select
                                        >
                                            {Helpers.GetDDIPaises().map(item => (
                                                <MenuItem key={item.value} value={item.value}>{item.label}</MenuItem>
                                            ))}
                                        </TextField>
                                        {formulario.foneprefix === "+55" ?
                                            <InputMask
                                                mask="(99)9999-9999"
                                                maskChar={null}
                                                value={formulario.fone}
                                                onChange={(ev) => onChangeMask(ev)}
                                                disabled={readOnly}
                                            >
                                                {() => <TextField
                                                    className=""
                                                    label="Fone"
                                                    id="fone"
                                                    name="fone"
                                                    variant="outlined"
                                                    fullWidth
                                                    disabled={readOnly}
                                                    InputLabelProps={{
                                                        shrink: formulario.fone !== null
                                                    }}
                                                    InputProps={{
                                                        endAdornment: (
                                                            <InputAdornment position="end">
                                                                <a
                                                                    className="font-medium flex items-center p-8"
                                                                    href={"tel:" + formulario.foneprefix + formulario.fone}
                                                                    target="_blank"
                                                                    rel="noopener noreferrer"
                                                                >
                                                                    <MdPhone className="text-green text-20" />
                                                                </a>
                                                            </InputAdornment>
                                                        )
                                                    }}
                                                />
                                                }
                                            </InputMask>
                                            :
                                            <TextField
                                                className=""
                                                label="Fone"
                                                id="fone"
                                                name="fone"
                                                variant="outlined"
                                                fullWidth
                                                value={formulario.fone}
                                                onChange={(ev) => onChangeMask(ev)}
                                                disabled={readOnly}
                                                InputLabelProps={{
                                                    shrink: formulario.fone !== null
                                                }}
                                                InputProps={{
                                                    endAdornment: (
                                                        <InputAdornment position="end">
                                                            <a
                                                                className="font-medium flex items-center p-8"
                                                                href={"tel:" + formulario.foneprefix + formulario.fone}
                                                                target="_blank"
                                                                rel="noopener noreferrer"
                                                            >
                                                                <MdPhone className="text-green text-20" />
                                                            </a>
                                                        </InputAdornment>
                                                    )
                                                }}
                                            />
                                        }
                                    </div>
                                    <div className="flex mb-12 md:w-1/3 xs:w-full md:mr-8">
                                        <TextField
                                            className="mb-12 mr-4 md:mr-8 w-96"
                                            id="celularprefix"
                                            name="celularprefix"
                                            variant="outlined"
                                            value={formulario.celularprefix}
                                            fullWidth
                                            onChange={onChange}
                                            disabled={readOnly}
                                            select
                                        >
                                            {Helpers.GetDDIPaises().map(item => (
                                                <MenuItem key={item.value} value={item.value}>{item.label}</MenuItem>
                                            ))}
                                        </TextField>
                                        {formulario.celularprefix === "+55" ?
                                            <InputMask
                                                mask="(99)99999-9999"
                                                maskChar={null}
                                                value={formulario.celular}
                                                onChange={(ev) => onChangeMask(ev)}
                                                disabled={readOnly}
                                            >
                                                {() => <TextField
                                                    className=""
                                                    label="Celular"
                                                    id="celular"
                                                    name="celular"
                                                    variant="outlined"
                                                    fullWidth
                                                    disabled={readOnly}
                                                    InputLabelProps={{
                                                        shrink: formulario.celular !== null
                                                    }}
                                                    InputProps={{
                                                        endAdornment: (
                                                            <InputAdornment position="end">
                                                                <a
                                                                    className="font-medium flex items-center p-8"
                                                                    href={"tel:" + formulario.celularprefix + formulario.celular}
                                                                    target="_blank"
                                                                    rel="noopener noreferrer"
                                                                >
                                                                    <MdPhoneAndroid className="text-green text-20" />
                                                                </a>
                                                            </InputAdornment>
                                                        )
                                                    }}
                                                />
                                                }
                                            </InputMask>
                                            :
                                            <TextField
                                                className=""
                                                label="Celular"
                                                id="celular"
                                                name="celular"
                                                variant="outlined"
                                                fullWidth
                                                value={formulario.celular}
                                                onChange={(ev) => onChangeMask(ev)}
                                                disabled={readOnly}
                                                InputLabelProps={{
                                                    shrink: formulario.celular !== null
                                                }}
                                                InputProps={{
                                                    endAdornment: (
                                                        <InputAdornment position="end">
                                                            <a
                                                                className="font-medium flex items-center p-8"
                                                                href={"tel:" + formulario.celularprefix + formulario.celular}
                                                                target="_blank"
                                                                rel="noopener noreferrer"
                                                            >
                                                                <MdPhoneAndroid className="text-green text-20" />
                                                            </a>
                                                        </InputAdornment>
                                                    )
                                                }}
                                            />
                                        }
                                    </div>
                                    <div className="flex mb-12 md:w-1/3 xs:w-full">
                                        <TextField
                                            className="mb-12 mr-4 md:mr-8 w-96"
                                            id="whatsappprefix"
                                            name="whatsappprefix"
                                            variant="outlined"
                                            value={formulario.whatsappprefix}
                                            fullWidth
                                            onChange={onChange}
                                            disabled={readOnly}
                                            select
                                        >
                                            {Helpers.GetDDIPaises().map(item => (
                                                <MenuItem key={item.value} value={item.value}>{item.label}</MenuItem>
                                            ))}
                                        </TextField>
                                        {formulario.whatsappprefix === "+55" ?
                                            <InputMask
                                                mask="(99)99999-9999"
                                                maskChar={null}
                                                value={formulario.whatsapp}
                                                onChange={(ev) => onChangeMask(ev)}
                                                disabled={readOnly}
                                            >
                                                {() => <TextField
                                                    className=""
                                                    label="Whatsapp"
                                                    id="whatsapp"
                                                    name="whatsapp"
                                                    variant="outlined"
                                                    fullWidth
                                                    disabled={readOnly}
                                                    InputLabelProps={{
                                                        shrink: formulario.whatsapp !== null
                                                    }}
                                                    InputProps={{
                                                        endAdornment: (
                                                            <InputAdornment position="end">
                                                                <a
                                                                    className="font-medium flex items-center p-8"
                                                                    href={"https://wa.me/" + formulario.whatsappprefix + formulario.whatsapp}
                                                                    target="_blank"
                                                                    rel="noopener noreferrer"
                                                                >
                                                                    <FaWhatsapp className="text-green text-20" />
                                                                </a>
                                                            </InputAdornment>
                                                        )
                                                    }}
                                                />
                                                }
                                            </InputMask>
                                            :
                                            <TextField
                                                className=""
                                                label="Whatsapp"
                                                id="whatsapp"
                                                name="whatsapp"
                                                variant="outlined"
                                                fullWidth
                                                value={formulario.whatsapp}
                                                onChange={(ev) => onChangeMask(ev)}
                                                disabled={readOnly}
                                                InputLabelProps={{
                                                    shrink: formulario.whatsapp !== null
                                                }}
                                                InputProps={{
                                                    endAdornment: (
                                                        <InputAdornment position="end">
                                                            <a
                                                                className="font-medium flex items-center p-8"
                                                                href={"https://wa.me/" + formulario.whatsappprefix + formulario.whatsapp}
                                                                target="_blank"
                                                                rel="noopener noreferrer"
                                                            >
                                                                <FaWhatsapp className="text-green text-20" />
                                                            </a>
                                                        </InputAdornment>
                                                    )
                                                }}
                                            />
                                        }
                                    </div>
                                </div>
                                <div className="flex sm:flex-no-wrap flex-wrap">
                                    <TextField
                                        className="mb-12 lg:w-1/3 xs:w-full md:mr-8"
                                        label={"Email"}
                                        id="email"
                                        name="email"
                                        disabled={readOnly}
                                        value={formulario.email}
                                        onChange={onChange}
                                        variant="outlined"
                                        fullWidth
                                        InputLabelProps={{
                                            shrink: formulario.email !== null
                                        }}
                                        InputProps={{
                                            endAdornment: (
                                                <InputAdornment position="end">
                                                    <a
                                                        className="font-medium flex items-center p-8"
                                                        href={"mailto:" + formulario.email}
                                                        target="_blank"
                                                        rel="noopener noreferrer"
                                                    >
                                                        <MdMail className="text-yellow-dark text-20" />
                                                    </a>
                                                </InputAdornment>
                                            )
                                        }}
                                    />
                                    <TextField
                                        className="mb-12 lg:w-1/3 xs:w-full md:mr-8"
                                        label={"Facebook"}
                                        id="facebook"
                                        name="facebook"
                                        disabled={readOnly}
                                        value={formulario.facebook}
                                        onChange={onChange}
                                        variant="outlined"
                                        fullWidth
                                        InputLabelProps={{
                                            shrink: formulario.facebook !== null
                                        }}
                                        InputProps={{
                                            endAdornment: (
                                                <InputAdornment position="end">
                                                    <a
                                                        className="font-medium flex items-center p-8"
                                                        href={md.mobile() === null && md.tablet() === null ? ("https://www.facebook.com/" + formulario.facebook) : ("fb://profile/" + formulario.facebook)}
                                                        target="_blank"
                                                        rel="noopener noreferrer"
                                                    >
                                                        <FaFacebook className="text-blue text-20" />
                                                    </a>
                                                </InputAdornment>
                                            )
                                        }}
                                    />
                                    <TextField
                                        className="mb-12 lg:w-1/3 xs:w-full md:mr-8"
                                        label={"Instagram"}
                                        id="instagram"
                                        name="instagram"
                                        disabled={readOnly}
                                        value={formulario.instagram}
                                        onChange={onChange}
                                        variant="outlined"
                                        fullWidth
                                        InputLabelProps={{
                                            shrink: formulario.instagram !== null
                                        }}
                                        InputProps={{
                                            endAdornment: (
                                                <InputAdornment position="end">
                                                    <a
                                                        className="font-medium flex items-center p-8"
                                                        href={md.mobile() === null && md.tablet() === null ? ("https://www.instagram.com/" + formulario.instagram) : ("instagram://user?username=" + formulario.instagram)}
                                                        target="_blank"
                                                        rel="noopener noreferrer"
                                                    >
                                                        <FaInstagram className="text-purple text-20" />
                                                    </a>
                                                </InputAdornment>
                                            )
                                        }}
                                    />
                                    <TextField
                                        className="mb-12 lg:w-1/3 xs:w-full"
                                        label={"Webex"}
                                        id="webex"
                                        name="webex"
                                        disabled={readOnly}
                                        value={formulario.webex}
                                        onChange={onChange}
                                        variant="outlined"
                                        fullWidth
                                        InputLabelProps={{
                                            shrink: formulario.webex !== null
                                        }}
                                        InputProps={{
                                            endAdornment: (
                                                <InputAdornment position="end">
                                                    <FaVideo className="text-blue text-20" />
                                                </InputAdornment>
                                            )
                                        }}
                                    />
                                </div>
                            </Collapse>
                        </React.Fragment>
                    }
                    {/** DADOS ADICIONAIS */}
                    {!_.isNull(customProps) && customProps["dadosadicionais"].show &&
                        <React.Fragment>
                            <div className="flex px-8 items-center cursor-pointer" onClick={() => this.openCollapse(6)}>
                                <Typography className="inline font-medium" color="primary" paragraph={false}>
                                    {"Dados adicionais"}
                                </Typography>
                                <div className="flex-1" />
                                <XAPPButton
                                    noHover={true}
                                    type="icon"
                                    icon={form.openCollapse === 6 ? "arrow_up" : "arrow_down"}
                                    onClick={() => { }}
                                />
                            </div>
                            <Collapse in={form.openCollapse === 6} timeout="auto" unmountOnExit className="">

                                <div className="flex sm:flex-no-wrap flex-wrap">
                                    <InputMask
                                        mask={formulario.natureza === "2" ? "99.999.999/9999-99" : "999.999.999-99"}
                                        maskChar={null}
                                        value={formulario.documentoprimario}
                                        onChange={(ev) => onChangeMask(ev)}
                                        disabled={readOnly}
                                    >
                                        {() => <TextField
                                            className="mb-12 lg:w-1/2 sm:w-full md:mr-8"
                                            label={formulario.natureza === "2" ? "CNPJ" : "CPF"}
                                            id="documentoprimario"
                                            name="documentoprimario"
                                            variant="outlined"
                                            fullWidth
                                            disabled={readOnly}
                                            InputLabelProps={{
                                                shrink: formulario.documentoprimario !== null
                                            }}
                                        />}
                                    </InputMask>
                                    <TextField
                                        className="mb-12 lg:w-1/2 sm:w-full"
                                        label={formulario.natureza === "2" ? "Inscrição estadual" : "RG"}
                                        id="documentosecundario"
                                        name="documentosecundario"
                                        disabled={readOnly}
                                        value={formulario.documentosecundario}
                                        onChange={onChange}
                                        variant="outlined"
                                        fullWidth
                                        InputLabelProps={{
                                            shrink: formulario.documentosecundario !== null
                                        }}
                                    />
                                </div>
                                <div className="flex sm:flex-no-wrap flex-wrap">
                                    {formulario.natureza === "1" &&

                                        <TextField
                                            className="mb-12 lg:w-1/2 sm:w-full md:mr-8"
                                            label={"Estado civil"}
                                            id="estadocivil"
                                            name="estadocivil"
                                            disabled={readOnly}
                                            value={formulario.estadocivil}
                                            onChange={onChange}
                                            variant="outlined"
                                            fullWidth
                                            select
                                            InputLabelProps={{
                                                shrink: formulario.estadocivil !== null
                                            }}
                                        >
                                            <MenuItem key={"MenuItem_" + 1} value={1}>{"Solteiro(a)"}</MenuItem>
                                            <MenuItem key={"MenuItem_" + 2} value={2}>{"Casado(a)"}</MenuItem>
                                            <MenuItem key={"MenuItem_" + 3} value={3}>{"Viúvo(a)"}</MenuItem>
                                            <MenuItem key={"MenuItem_" + 4} value={4}>{"Outro"}</MenuItem>
                                        </TextField>
                                    }
                                    <TextField
                                        className={clsx("mb-12", formulario.natureza === "2" ? "w-full" : "lg:w-1/2 sm:w-full")}
                                        label={formulario.natureza === "2" ? "Segmento" : "Profissão"}
                                        id="segmentoprofissao"
                                        name="segmentoprofissao"
                                        disabled={readOnly}
                                        value={formulario.segmentoprofissao}
                                        onChange={onChange}
                                        variant="outlined"
                                        fullWidth
                                        InputLabelProps={{
                                            shrink: formulario.segmentoprofissao !== null
                                        }}
                                    />
                                </div>

                                {/** DADOS ESPECIALIZAÇÃO */}
                                {formulario.natureza === "1" &&
                                    <div className="flex sm:flex-no-wrap flex-wrap">
                                        <TextField
                                            className="mb-12 lg:w-2/6 sm:w-full md:mr-8"
                                            label={"Registro conselho"}
                                            id="registroconselho"
                                            name="registroconselho"
                                            disabled={readOnly}
                                            value={formulario.registroconselho}
                                            onChange={onChange}
                                            variant="outlined"
                                            fullWidth
                                            InputLabelProps={{
                                                shrink: formulario.registroconselho !== null
                                            }}
                                        />
                                        <TextField
                                            className="mb-12 lg:w-1/6 sm:w-full md:mr-8"
                                            label={"UF"}
                                            id="registroconselhouf"
                                            name="registroconselhouf"
                                            disabled={readOnly}
                                            value={formulario.registroconselhouf}
                                            onChange={onChange}
                                            variant="outlined"
                                            fullWidth
                                            select
                                            InputLabelProps={{
                                                shrink: formulario.registroconselhouf !== null
                                            }}
                                        >
                                            {Helpers.GetUFs().map(item => (
                                                <MenuItem key={"MenuItem_" + item.id} value={item.id}>{item.label}</MenuItem>
                                            ))}
                                        </TextField>
                                        <TextField
                                            className="mb-12 lg:w-2/6 sm:w-full md:mr-8"
                                            label={"Registro especialista"}
                                            id="registroespecialista"
                                            name="registroespecialista"
                                            disabled={readOnly}
                                            value={formulario.registroespecialista}
                                            onChange={onChange}
                                            variant="outlined"
                                            fullWidth
                                            InputLabelProps={{
                                                shrink: formulario.registroespecialista !== null
                                            }}
                                        />
                                        <TextField
                                            className="mb-12 lg:w-1/6 sm:w-full"
                                            label={"UF"}
                                            id="registroespecialistauf"
                                            name="registroespecialistauf"
                                            disabled={readOnly}
                                            value={formulario.registroespecialistauf}
                                            onChange={onChange}
                                            variant="outlined"
                                            select
                                            fullWidth
                                            InputLabelProps={{
                                                shrink: formulario.registroespecialistauf !== null
                                            }}
                                        >
                                            {Helpers.GetUFs().map(item => (
                                                <MenuItem key={"MenuItem_" + item.id} value={item.id}>{item.label}</MenuItem>
                                            ))}
                                        </TextField>
                                    </div>
                                }
                            </Collapse>
                        </React.Fragment>
                    }
                    {/** ENDEREÇO RESIDENCIAL */}
                    {!_.isNull(customProps) && customProps["enderecoresidencial"].show &&
                        <React.Fragment>
                            <div className="flex px-8 items-center cursor-pointer" onClick={() => this.openCollapse(1)}>
                                <Typography className="inline font-medium" color="primary" paragraph={false}>
                                    {"Endereço residencial"}
                                </Typography>
                                <div className="flex-1" />
                                <XAPPButton
                                    noHover={true}
                                    type="icon"
                                    icon={form.openCollapse === 1 ? "arrow_up" : "arrow_down"}
                                    onClick={() => { }}
                                />
                            </div>
                            <Collapse in={form.openCollapse === 1} timeout="auto" unmountOnExit className="">
                                <React.Fragment>
                                    <div className="flex sm:flex-no-wrap flex-wrap">
                                        <TextField
                                            className="mb-12 lg:w-1/3 xs:w-full md:mr-8"
                                            label={"Logradouro"}
                                            id="logradouro1"
                                            name="logradouro1"
                                            disabled={readOnly}
                                            value={formulario.logradouro1}
                                            onChange={onChange}
                                            variant="outlined"
                                            fullWidth
                                            InputLabelProps={{
                                                shrink: formulario.logradouro1 !== null
                                            }}
                                        />
                                        <TextField
                                            className="mb-12 lg:w-1/3 xs:w-full md:mr-8"
                                            label={"Numero"}
                                            id="numero1"
                                            name="numero1"
                                            disabled={readOnly}
                                            value={formulario.numero1}
                                            onChange={onChange}
                                            variant="outlined"
                                            fullWidth
                                            InputLabelProps={{
                                                shrink: formulario.numero1 !== null
                                            }}
                                        />
                                        <TextField
                                            className="mb-12 lg:w-1/3 xs:w-full"
                                            label={"Bairro"}
                                            id="bairro1"
                                            name="bairro1"
                                            disabled={readOnly}
                                            value={formulario.bairro1}
                                            onChange={onChange}
                                            variant="outlined"
                                            fullWidth
                                            InputLabelProps={{
                                                shrink: formulario.bairro1 !== null
                                            }}
                                        />
                                    </div>
                                    <div className="flex sm:flex-no-wrap flex-wrap">
                                        <InputMask
                                            mask={"99999-999"}
                                            maskChar={null}
                                            value={formulario.cep1}
                                            onChange={(ev) => onChangeMask(ev)}
                                            disabled={readOnly}
                                        >
                                            {() => <TextField
                                                className="mb-12 lg:w-1/3 xs:w-full md:mr-8"
                                                label={"CEP"}
                                                id="cep1"
                                                name="cep1"
                                                variant="outlined"
                                                fullWidth
                                                disabled={readOnly}
                                                InputLabelProps={{
                                                    shrink: formulario.cep1 !== null
                                                }}
                                            />}
                                        </InputMask>
                                        <TextField
                                            className="mb-12 lg:w-1/3 xs:w-full md:mr-8"
                                            label={"Complemento"}
                                            id="complemento1"
                                            name="complemento1"
                                            disabled={readOnly}
                                            value={formulario.complemento1}
                                            onChange={onChange}
                                            variant="outlined"
                                            fullWidth
                                            InputLabelProps={{
                                                shrink: formulario.complemento1 !== null
                                            }}
                                        />
                                        <CidadeApp
                                            xappRouteParams={xappRouteParams}
                                            isLookup={true}
                                            multiSelect={false}
                                            id="PessoaCidade1"
                                            onChange={(ev) => this.handleLookupCidade(ev, "cidade1")}
                                            readOnly={readOnly}
                                            selected={formulario.cidade1 ? ([{
                                                "cidade1": formulario.cidade1,
                                                "id": formulario.cidade1,
                                                "cidade1_nome": formulario.cidade1_nome,
                                                "cidade": formulario.cidade1_nome
                                            }]) : []}
                                            className="mb-12 lg:w-1/3 xs:w-full flex flex-col"
                                            label={"Cidade"}
                                        />
                                    </div>
                                </React.Fragment>
                            </Collapse>
                        </React.Fragment>
                    }
                    {/** ENDEREÇO COMERCIAL */}
                    {!_.isNull(customProps) && customProps["enderecocomercial"].show &&
                        <React.Fragment>
                            <div className="flex px-8 items-center cursor-pointer" onClick={() => this.openCollapse(5)}>
                                <Typography className="inline font-medium" color="primary" paragraph={false}>
                                    {"Endereço comercial"}
                                </Typography>
                                <div className="flex-1" />
                                <XAPPButton
                                    noHover={true}
                                    type="icon"
                                    icon={form.openCollapse === 5 ? "arrow_up" : "arrow_down"}
                                    onClick={() => { }}
                                />
                            </div>
                            <Collapse in={form.openCollapse === 5} timeout="auto" unmountOnExit className="">
                                <div className='flex flex-row items-center sm:flex-no-wrap flex-wrap'>
                                    <div className="mb-12 mr-8">
                                        <ImageUploader
                                            onChange={this.handleImage}
                                            image={formulario.logotipo}
                                            name={"logotipo"}
                                            width={300}
                                            showtoolbar={true}
                                            height={250}
                                            border={50}
                                            scale={1}
                                            disabled={readOnly}
                                            resizeImage={false}
                                        />
                                    </div>
                                    <div className='w-full'>
                                        <div className="flex sm:flex-no-wrap flex-wrap">
                                            <TextField
                                                className="mb-12 lg:w-1/3 xs:w-full md:mr-8"
                                                label={"Logradouro"}
                                                id="logradouro5"
                                                name="logradouro5"
                                                disabled={readOnly}
                                                value={formulario.logradouro5}
                                                onChange={onChange}
                                                variant="outlined"
                                                fullWidth
                                                InputLabelProps={{
                                                    shrink: formulario.logradouro5 !== null
                                                }}
                                            />
                                            <TextField
                                                className="mb-12 lg:w-1/3 xs:w-full md:mr-8"
                                                label={"Numero"}
                                                id="numero5"
                                                name="numero5"
                                                disabled={readOnly}
                                                value={formulario.numero5}
                                                onChange={onChange}
                                                variant="outlined"
                                                fullWidth
                                                InputLabelProps={{
                                                    shrink: formulario.numero5 !== null
                                                }}
                                            />
                                            <TextField
                                                className="mb-12 lg:w-1/3 xs:w-full"
                                                label={"Bairro"}
                                                id="bairro5"
                                                name="bairro5"
                                                disabled={readOnly}
                                                value={formulario.bairro5}
                                                onChange={onChange}
                                                variant="outlined"
                                                fullWidth
                                                InputLabelProps={{
                                                    shrink: formulario.bairro5 !== null
                                                }}
                                            />
                                        </div>
                                        <div className="flex sm:flex-no-wrap flex-wrap">
                                            <InputMask
                                                mask={"99999-999"}
                                                maskChar={null}
                                                value={formulario.cep5}
                                                onChange={(ev) => onChangeMask(ev)}
                                                disabled={readOnly}
                                            >
                                                {() => <TextField
                                                    className="mb-12 lg:w-1/3 xs:w-full md:mr-8"
                                                    label={"CEP"}
                                                    id="cep5"
                                                    name="cep5"
                                                    variant="outlined"
                                                    fullWidth
                                                    disabled={readOnly}
                                                    InputLabelProps={{
                                                        shrink: formulario.cep5 !== null
                                                    }}
                                                />}
                                            </InputMask>
                                            <TextField
                                                className="mb-12 lg:w-1/3 xs:w-full md:mr-8"
                                                label={"Complemento"}
                                                id="complemento5"
                                                name="complemento5"
                                                disabled={readOnly}
                                                value={formulario.complemento5}
                                                onChange={onChange}
                                                variant="outlined"
                                                fullWidth
                                                InputLabelProps={{
                                                    shrink: formulario.complemento5 !== null
                                                }}
                                            />
                                            <CidadeApp
                                                xappRouteParams={xappRouteParams}
                                                isLookup={true}
                                                multiSelect={false}
                                                id="PessoaCidade5"
                                                onChange={(ev) => this.handleLookupCidade(ev, "cidade5")}
                                                readOnly={readOnly}
                                                selected={formulario.cidade5 ? ([{
                                                    "cidade5": formulario.cidade5,
                                                    "id": formulario.cidade5,
                                                    "cidade5_nome": formulario.cidade5_nome,
                                                    "cidade": formulario.cidade5_nome
                                                }]) : []}
                                                className="mb-12 lg:w-1/3 xs:w-full flex flex-col"
                                                label={"Cidade"}
                                            />
                                        </div>
                                    </div>
                                </div>
                            </Collapse>
                        </React.Fragment>
                    }
                    {/** Atendimento online */}
                    {!_.isNull(customProps) && customProps["atendimentoonline"].show &&
                        <React.Fragment>
                            <div className="flex px-8 items-center cursor-pointer" onClick={() => this.openCollapse(6)}>
                                <Typography className="inline font-medium" color="primary" paragraph={false}>
                                    {"Atendimento online"}
                                </Typography>
                                <div className="flex-1" />
                                <XAPPButton
                                    noHover={true}
                                    type="icon"
                                    icon={form.openCollapse === 6 ? "arrow_up" : "arrow_down"}
                                    onClick={() => { }}
                                />
                            </div>
                            <Collapse in={form.openCollapse === 6} timeout="auto" unmountOnExit className="">
                                <div className='flex flex-row items-center sm:flex-no-wrap flex-wrap'>
                                    <div className='w-full'>
                                        <div className="flex sm:flex-no-wrap flex-wrap">
                                            <FormControl className="items-center">
                                                <FormControlLabel
                                                    label={"Cobrança online"}
                                                    className={"mb-12 ml-4"}
                                                    control={
                                                        <Checkbox
                                                            id={"cobrancaonline"}
                                                            name={"cobrancaonline"}
                                                            checked={formulario.cobrancaonline === 1}
                                                            disabled={readOnly}
                                                            onChange={(ev) => onChange({ "target": { "type": "checkbox", "name": "cobrancaonline", "checked": ev.target.checked ? 1 : 0 } })}
                                                        />
                                                    }
                                                />
                                            </FormControl>
                                        </div>
                                        <div className="flex sm:flex-no-wrap flex-wrap">
                                            <TextField
                                                className="mb-12 w-full mr-8"
                                                label={"Índice público"}
                                                id="indice"
                                                name="indice"
                                                disabled={readOnly}
                                                value={formulario.indice ?? "1"}
                                                onChange={onChange}
                                                variant="outlined"
                                                type="number"
                                                fullWidth
                                                InputLabelProps={{
                                                    shrink: formulario.indice !== null
                                                }}
                                            />
                                            <TextField
                                                className="mb-12 w-full"
                                                label={"Especialidade"}
                                                id="especialidade"
                                                name="especialidade"
                                                disabled={readOnly}
                                                value={formulario.especialidade}
                                                onChange={onChange}
                                                variant="outlined"
                                                fullWidth
                                                InputLabelProps={{
                                                    shrink: formulario.indice !== null
                                                }}
                                            />
                                        </div>
                                        <div className="flex sm:flex-no-wrap flex-wrap">
                                            <TextField
                                                className="mb-12 w-full"
                                                label={"Descrição pública"}
                                                id="descricaopublica"
                                                name="descricaopublica"
                                                disabled={readOnly}
                                                value={formulario.descricaopublica}
                                                onChange={onChange}
                                                variant="outlined"
                                                fullWidth
                                                rows={3}
                                                rowsMax={3}
                                                InputLabelProps={{
                                                    shrink: formulario.descricaopublica !== null
                                                }}
                                            />
                                        </div>
                                    </div>
                                </div>
                            </Collapse>
                        </React.Fragment>
                    }
                    {/** OUTROS DADOS */}
                    <React.Fragment>
                        <div className="flex p-8 items-center">
                            <Typography className="inline font-medium" color="primary" paragraph={false}>
                                {"Outros"}
                            </Typography>
                        </div>
                        {!_.isNull(customProps) && customProps["alergias"].show &&
                            <div className='flex flex-col w-full sm:flex-no-wrap flex-wrap'>
                                <div className="flex sm:flex-no-wrap flex-wrap w-full">
                                    <TextField
                                        className="mb-12 w-full"
                                        label={"Alergias"}
                                        id="alergias"
                                        name="alergias"
                                        disabled={readOnly}
                                        value={formulario.alergias}
                                        onChange={onChange}
                                        variant="outlined"
                                        fullWidth
                                        InputLabelProps={{
                                            shrink: formulario.alergias !== null
                                        }}
                                    />
                                </div>
                            </div>
                        }
                        <div className='flex flex-col w-full sm:flex-no-wrap flex-wrap'>
                            <div className="flex sm:flex-no-wrap flex-wrap w-full">
                                <TextField
                                    className="mb-12 w-full"
                                    label={"Observações"}
                                    id="observacao"
                                    name="observacao"
                                    disabled={readOnly}
                                    value={formulario.observacao}
                                    onChange={onChange}
                                    variant="outlined"
                                    fullWidth
                                    multiline
                                    rows={3}
                                    rowsMax={10}
                                    InputLabelProps={{
                                        shrink: formulario.observacao !== null
                                    }}
                                />
                            </div>
                        </div>
                        {!_.isNull(customProps) && customProps["centrocusto"].show &&
                            <div className='flex flex-col w-full sm:flex-no-wrap flex-wrap'>
                                <div className="flex sm:flex-no-wrap flex-wrap w-full">
                                    <EmpresaCentroCustoApp
                                        className="mt-16"
                                        xappRouteParams={xappRouteParams}
                                        required={false}
                                        isLookup={true}
                                        multiSelect={false}
                                        onChange={this.handleLookupEmpresaCentroCusto}
                                        id="CentroCustoDefault"
                                        key="CentroCustoDefault"
                                        label="Centro de custo padrão"
                                        selected={formulario.idpessoaformulariocentrocusto ? [{ idpessoaformulario: formulario.idpessoaformulariocentrocusto, nome: formulario.idpessoaformulariocentrocustodescricao }] : []}
                                        target="spvwempresacentrocustolookup"
                                    />
                                </div>
                            </div>
                        }
                    </React.Fragment>
                </div>
            </React.Fragment>

        );
    }
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        changeFuncionario: Actions.changeFuncionario,
        showMessage: AppActions.showMessage,
    }, dispatch);
}

function mapStateToProps({ FormPessoa }) {
    return {
        FormPessoa: FormPessoa,
    };
}

export default withReducer("FormPessoa", reducer)(withStyles(styles, { withTheme: true })(withRouter(connect(mapStateToProps, mapDispatchToProps)(FormPessoa))));
